// extracted by mini-css-extract-plugin
export default {"section":"RegisterSuccessPage_section__Fw9zh","box":"RegisterSuccessPage_box__1npiI","eyebrow":"RegisterSuccessPage_eyebrow__++gav","button":"RegisterSuccessPage_button__HZ6O9"};